import styled from 'styled-components';

export const ItemContent = styled.div``;
